module.exports = __webpack_public_path__ + "img/tlf_dep3.405f6cae.png";